import { makeStyles } from "@material-ui/core";
import { colors } from "global/react-mui/theme/colors";

const useStyles = makeStyles((theme) => ({
	labelWrapper: {
		'& > *:first-child': {
			marginTop: 0,
			marginBottom: 0,
		},
		'& > * + *': {
			marginTop: 16,
			marginBottom: 0,
		},
		'& a': {
			// colors usually come from uk-link so add styles
			color: colors["wolf-red"],
		}
	},
	label: {
		[theme.breakpoints.down('md')]: {
			'& span': {
				color: colors["text-grey"],
				fontSize: 14,
			},
		},
	},
	checkbox: {
		[theme.breakpoints.down('md')]: {
			'& svg': {
				fill: colors["text-grey"],
			},
		},
	},
	validationWrapper: {
		padding: 12,
		color: colors["wolf-red"],
	},
}));

export default useStyles
